<template>
  <section   
    class="insu-prod-wrapper"
  >  
    <div class="container" >    
      <template >  
         

        <div v-if="details" ref="details">
           <div class="clearfix mb-s insu-prod-premiums">
             <br />
              
        <h2 class="title section-title">{{ `${details[0].insuCompany} ${details[0].insuName}` }}</h2>
    <!--    <div class="pull-right premiums-right">
          <span class="premiums">{{ `${details[0].premiums} 元` }}</span>
        </div> 
--> 
<div class="pull-right premiums-right">
    <div class="text-right" >
          <Button
            size="large"
            class="btn-m btn-primary"
            @click="handlePurchase1(details[0])"
          >
            <span>原方案續保</span>
           
          </Button> 
          <span class="pl-s"></span>                     
       <router-link :to="red_url" > <Button
            size="large"
            class="btn-m btn-primary">變更方案續保</Button></router-link>
 </div> 
 </div> 
 </div> 
         <div class="insu-prod-details">
        <InsuProdDetailList 
          v-for="(data, i) in details[0].lists"
          :key="i"
          :data="data"
        />
      </div>
      <InsuProdPolicies :prodPolicies="details[0].prodPolicies" />     
        </div>
      </template> 
    </div>
  </section>
</template>

<script>
  import axios, { generateAuthPostConf  } from '@/utils/axios';
  import { mapMutations,mapActions } from 'vuex';
  
  // components  
   import { Button, Row, Col } from 'iview';
   import router from '@/router';
     import InsuProdDetailList from '@/components/insurance/InsuProdDetailList';
  import InsuProdPolicies from '@/components/insurance/InsuProdPolicies';
 // import InsuProdDetailsModal from '@/components/modals/InsuProdDetailsModal';
   // constants
  //import { SELECT_INSU_MUTATION } from '@/store/modules/insurance/constants';
 // asyncValidator
  //import { carRules, motorRules } from '@/utils/asyncValidator/queryForms';
 /* import { 
  SET_INSUINFOS,
  SET_CHECKOUT_PRODPOLICIES
} from '@store/modules/checkout/constants';*/
 import {    
    HANDLE_PURCHASE_ACTION1
    //,    SELECT_INSU_MUTATION
  } from  // '@/store/modules/insurance/constants';
    '@/store/modules/renewal/constants';
  export default {
    components: {
      Button,
      Row,
      Col,
      InsuProdDetailList,
      InsuProdPolicies
    //  InsuProdDetailsModal
    }, 
    //  [SET_INSUPERIOD]: setInsuPeriod,
   //   [SET_CHECKOUT_PRODPOLICIES]: setCheckoutProdplicies,
    rules: {
        type: Object,
        default() {
          return this.type === 'car' ? carRules : motorRules;
        } 
      },
    props: {     
      no:{
        type: String,
        default: null
      },
      type:
      {
        type: String,
        default: null
      },
      red_url:
      {
        type:String,
        default:'/insurance/'

      }
      ,
      details: {
        type: Object,
        default: null
      },
      insuInfo: {
        type: Array,
        default: () => [
          {
            insuCompany: '',
            insuId:{
              type: String,
              default: null
            } ,
            insuName: {
              type: String,
              default: null
            } ,
            isCompulsory: true
          }
        ]
      },   
      prodPolicies: {
        type: Array,
        default: null
      },   
      insuId:
      {
        type: String,
      },
      carProfile: {
        type: Object,
      default: () => ({
        carNo: {
          block1: '',
          block2: '',
          carType: ''          
        }
      })
    },
    insur_type:
    {
      type: String,
      default: null
     },
    insurtype_date:
    {
      type: String,
      default: null
      },
    /*vaccineInceptionDate:
      {
      type: String,
      default: ''
      },*/
      vaccineFilter:{
        type:Object,
        default:() => ({          
          vaccineInceptionDate:{
            type: String,
            default: ''
          }
        })
      },
    petFilter:{
      type: Object,
      default: () => ({
        typeOfPet:{
        type: String,
        default: ''
        },
        dateOfBirthPet:{
        type: Object,
        default: () => ({
          year: '',
          month: '',
          day: ''
        })
      },
        petName:{
        type: String,
        default: ''
        },
        petGender:{
        type: String,
        default: 'M'
        },
        petNo:{
        type: String,
        default: ''
        },
        petBreed:{
        type: String,
        default: ''
        },
        petColor:{
        type: String,
        default: ''
        },
        petWeight:{
        type: Number,
        default: 0
        } ,
        petInceptionDate:{
            type: String,
            default: ''
          }     
      })
       },
       dateOfBirthPet:{
        type: Object,
        default: () => ({
          year: '',
          month: '',
          day: ''
        })
      },
      handlePurchase1: {
        type: Function,
        default: () => {}
      }
}   ,  
  data() {
    return {      
      no:''
    }
  },
  beforeMount() 
  {          
      this.no=this.$route.params.no;     
      this.initRenewal();

  },
  mounted() {       
    },
    beforeDestroy() {        
    },
  methods: {   
      handleSelect(val) {
       
        if (!val) return this.handleReset();
        // handleSelect       
        const payload = val;
      },   
     ...mapActions([       
        //FETCH_DETAILS_ACTION,
        HANDLE_PURCHASE_ACTION1
      ]),
      async initRenewal() {       
        const  orderId  =this.$route.params.no;     
        //console.log("orderId"+orderId);
        const config = generateAuthPostConf('Orders/renewal', { orderId });
        const { data } = await axios(config);
        const { reviews } = data.result;       
        this.details = data.result;
        this.insuInfo=this.details[0];
        this.carProfile.carNo = this.details[0].carNo;
        this.type=this.carProfile.carNo.carType;
        var { inceptionDate }= this.details[0].vcn;
        this.vaccineFilter.vaccineInceptionDate = inceptionDate;
       // console.log("initRenewal-details"+JSON.stringify(this.details));          
        this.petFilter = this.details[0].pet;       
        const { dateOfBirthPet } =this.petFilter;    
        //const { year,month,day } =this.petFilter.dateOfBirthPet;   
        this.dateOfBirthPet.year=dateOfBirthPet.split('/')[0];
        this.dateOfBirthPet.month=dateOfBirthPet.split('/')[1];
        this.dateOfBirthPet.day=dateOfBirthPet.split('/')[2];
        this.petFilter.dateOfBirthPet=this.dateOfBirthPet;
        this.petFilter.petInceptionDate=inceptionDate;
        //console.log("petFilter    "+JSON.stringify(this.petFilter));
        this.red_url+=this.type+"/"; //this.red_url+=this.type+"/"+this.carProfile.carNo.block1+"-"+this.carProfile.carNo.block2; 
        if  (this.type=='motor' ||this.type=='car'){
          this.red_url+=this.carProfile.carNo.block1+"-"+this.carProfile.carNo.block2; 
        }         
                  
      },     
      handlePurchase1(prodDetail) {
        //console.log(JSON.stringify(prodDetail));
        //console.log("+this.carProfile.carNo.carType+"+JSON.stringify(this.carProfile.carNo.carType));
        if (this.carProfile.carNo.carType=='car' ||this.carProfile.carNo.carType=='motor')
          //type-car ,prodPolicies,profile
          this.HANDLE_PURCHASE_ACTION1({prodDetail,queryModel:this.carProfile,type: this.carProfile.carNo.carType});   
        else if(this.carProfile.carNo.carType=='pet')
          //type-pet    
          this.HANDLE_PURCHASE_ACTION1({prodDetail,queryModel:this.petFilter,type: this.carProfile.carNo.carType});   
        else if(this.carProfile.carNo.carType=='vaccine')
         this.HANDLE_PURCHASE_ACTION1({prodDetail,queryModel:this.vaccineFilter,type: this.carProfile.carNo.carType});  
          // type-vaccine
      }, 
      handlePagePurchase1(dd) {
  //console.log("this.details[0]:"+JSON.stringify(this.details[0]));
   //console.log("this.details[0]dd:"+JSON.stringify(dd));  
    this.insuInfo.insuName= dd.insuName;//item.insuName,  
    this.insuInfo.insuCompany= dd.insuCompany;
    this.insuInfo.insuId= dd.insuId;   
 this.prodPolicies=dd.prodPolicies;  
    const type='car';    
  this.$route.params.insuInfo=this.insuInfo.insuId;
  //console.log("this.insuInfo.insuId: "+this.insuInfo.insuId);
  this.$store.commit(SET_INSUINFOS, { insuType: type, insuInfo:this.insuInfo });
  this.$store.commit(SET_CHECKOUT_PRODPOLICIES,{ prodPolicies:this.prodPolicies});
  router.push({ name: 'checkoutInfo', params: { insuType: type,insuInfo:this.insuInfo,insuId:this.insuInfo.insuId, carProfile:this.carProfile} });

      },
  }
}
</script>